import {SessionStorage} from "../../common/clientStorage";
import {autoRegister, resolve} from "../../container";

@autoRegister()
export class MacherbusStorage {

    private sessionStorageKey = "macherbus-v2";

    public constructor(private sessionStorage: SessionStorage = resolve(SessionStorage)) {
    }

    public saveVotes(votingId: string, projectIds: string[]): void {
        this.sessionStorage.saveInPath(this.sessionStorageKey, [votingId], projectIds);
    }

    public readVotes(votingId: string): string[] {
        return this.sessionStorage.fetchFromPath<string[]>([this.sessionStorageKey, votingId]) ?? [];
    }
}
